import React from 'react';
import { IconButton, Icon } from 'office-ui-fabric-react';

const getMediaIcons = (media) => {
    const icons = [];
    if (media) {
        if (media.audio && media.audio.isActive) icons.push('Microphone');
        if (media.video && media.video.isActive) icons.push('Video');
        if (media.screen && media.screen.isActive) icons.push('ScreenCast');
        if (media.chat && media.chat.isActive) icons.push('Chat');
    }
    return icons;
};


const RuleCard = ({ rule, onMoveUp, onMoveDown, onDelete, onEdit, isFirst, isLast, context }) => {
    const mediaIcons = getMediaIcons(rule?.filters?.recordingType?.media);
    return (

        <div className="card">
            <div className="card-title">{rule.name}</div>
            <div className="card-details">{rule.text}</div>
            <div className="inline-details">
                <span>
                    {Array.isArray(rule?.filters?.conversationType) && rule.filters.conversationType.length > 0
                        ? rule.filters.conversationType
                            .map(type => {
                                switch (type) {
                                    case "Inbound":
                                        return context.getTranslation("configuration", "inbound");
                                    case "Outbound":
                                        return context.getTranslation("configuration", "outbound");
                                    case "Internal":
                                        return context.getTranslation("configuration", "internal");
                                    case "InternalMeeting":
                                        return context.getTranslation("configuration", "meetingIntern");
                                    case "ExternalMeeting":
                                        return context.getTranslation("configuration", "meetingExtern");
                                    default:
                                        return type;
                                }
                            })
                            .join(', ')
                        : context.getTranslation("recordingRule", "allConversationTypes")
                    }
                </span>

                <div className="card-icons">
                    {mediaIcons.map((icon, index) => (
                        <Icon key={index} iconName={icon} className="card-icon" />
                    ))}
                </div>

                <div className="card-action-buttons">
                    <IconButton iconProps={{ iconName: 'Edit' }} onClick={onEdit} />
                    <IconButton iconProps={{ iconName: 'Delete' }} className="trash-icon" onClick={onDelete} />
                </div>
            </div>
            <div className="card-actions">
                {!isFirst && (
                    <IconButton iconProps={{ iconName: 'Up' }} onClick={onMoveUp} />
                )}
                {!isLast && (
                    <IconButton iconProps={{ iconName: 'Down' }} onClick={onMoveDown} />
                )}
            </div>
        </div>
    );
};

export default RuleCard;